type ScriptAttributes = Partial<Omit<HTMLScriptElement, 'src' | 'async'>>

export function scriptLoader(
  url: string,
  attributes?: ScriptAttributes,
  waitForLoadComplete?: boolean
): Promise<HTMLScriptElement> {
  return new Promise((resolve, reject) => {
    const script = window.document.createElement('script')
    script.src = url
    script.async = true

    Object.assign(script, attributes)

    script.addEventListener('load', () => {
      resolve(script)
    })

    script.addEventListener('error', reject, false)

    appendScript(script, waitForLoadComplete)
  })
}

function appendScript(script: HTMLScriptElement, defer?: boolean) {
  if (defer && 'complete' !== document.readyState) {
    document.addEventListener('readystatechange', () => {
      if ('complete' === document.readyState) document.body.appendChild(script)
    })
  } else {
    document.body.appendChild(script)
  }
}
